import React from 'react';
import { Wifi, Activity, Cloud, Laptop } from 'lucide-react';
import { useQzTrayClient } from '../../../hooks/qztray/useQzTrayClient';

/**
 * 🧭 ConnectionHeader
 *
 * Encabezado del panel de conexión QZ Tray.
 * Solo lee el estado (sin cargar ni conectar).
 */
const ConnectionHeader: React.FC = () => {
  const { config, isConnected } = useQzTrayClient();

  // 🧠 Determinar el modo basado en protocolo
  const protocol = config?.protocol || (config?.sslEnabled ? 'wss' : 'ws');
  const isLocal = protocol === 'ws';

  // 🏷️ Texto e ícono del modo
  const modeLabel = isLocal ? 'Modo Local' : 'Modo Nube Segura';
  const ModeIcon = isLocal ? Laptop : Cloud;

  return (
    <div className="relative flex flex-col gap-4 overflow-hidden rounded-lg border border-stroke bg-white p-6 shadow-md transition-all dark:border-strokedark dark:bg-boxdark sm:flex-row sm:items-center sm:justify-between">
      {/* 🔸 Lado izquierdo */}
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 dark:bg-primary/20">
          <Wifi className="h-6 w-6 animate-pulse text-primary" />
        </div>

        <div>
          <h2 className="text-gray-800 dark:text-gray-100 flex items-center gap-2 text-xl font-semibold">
            Monitor de Conexión
            <span className="text-sm font-medium tracking-wide text-primary/80">
              QZ Tray
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mt-0.5 text-sm">
            Estado actual del cliente local y modo de comunicación.
          </p>
        </div>
      </div>

      {/* 🔸 Lado derecho */}
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        {/* 🔹 Estado de conexión */}
        <div
          className={`flex items-center gap-2 rounded-md px-3 py-1.5 ${
            isConnected
              ? 'bg-[#3CA745] text-white' // verde conectado
              : 'bg-[#DC3545] text-white' // rojo desconectado
          }`}
        >
          <Activity
            className={`h-4 w-4 ${isConnected ? 'animate-pulse' : ''}`}
          />
          <span className="text-xs font-medium">
            {isConnected ? 'Conectado' : 'Desconectado'}
          </span>
        </div>

        {/* 🔹 Modo actual (Local o Nube) */}
        <div className="flex items-center gap-2 rounded-md bg-primary px-3 py-1.5 text-white shadow-sm">
          <ModeIcon className="h-4 w-4" />
          <span className="text-xs font-medium">{modeLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default ConnectionHeader;
